import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { MasterProductCounterEditPageRoutingModule } from './master-product-counter-edit-routing.module';

import { MasterProductCounterEditPage } from './master-product-counter-edit.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    MasterProductCounterEditPageRoutingModule
  ],
  declarations: [MasterProductCounterEditPage]
})
export class MasterProductCounterEditPageModule {}
